export enum CurrencyEnums {
  monedaLocal = 1
}